import React from 'react';
import DatePickerComponent from 'react-date-picker';

const DatePicker = (props) => {
  return <DatePickerComponent {...props} />;
};

export default DatePicker;
